import { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Card, Link, Container, Typography } from '@mui/material';
// hooks
import useResponsive from '../hooks/useResponsive';
// components
import Page from '../components/Page';
import Logo from '../components/Logo';
// sections
import TopUpForm from '../sections/auth/login/TopUp';
import AuthSocial from '../sections/auth/AuthSocial';


// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const HeaderStyle = styled('header')(({ theme }) => ({
  top: 0,
  zIndex: 9,
  lineHeight: 0,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  position: 'absolute',
  padding: theme.spacing(3),
  justifyContent: 'space-between',
  [theme.breakpoints.up('md')]: {
    alignItems: 'flex-start',
    padding: theme.spacing(7, 5, 0, 7),
  },
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 464,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: theme.spacing(2, 0, 2, 2),
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '50vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function Wallet() {
  const smUp = useResponsive('up', 'sm');

  const [wallet, setWallet] = useState("Loading Wallet...");

  const mdUp = useResponsive('up', 'md');

  const [user, setUser] = useState(
    {
      "status": true,
      "message": "Login successful!",
      "data": {
          "rating": "0",
          "availability": "offline",
          "status": true,
          "role": "artisan",
          "_id": "6303b359ae52850016ba2d95",
          "phone": "9135403118",
          "country_code": "234",
          "id": "6303b359ae52850016ba2d95",
          "token": "UEC2EAmYK3h31ssVRWLD8MQjQOapqo",
          "createdAt": "2022-08-22T16:48:25.655Z",
          "updatedAt": "2022-09-01T23:51:54.155Z",
          "__v": 0,
          "address_str": "10 Juliest ultimate Drive",
          "avatar": "avatar",
          "email": "omonicksonowoeye@gmail.com",
          "first_name": "Omoniyi",
          "last_name": "Omoniyi",
          "location": {
              "type": "Point",
              "coordinates": [
                  7.471104,
                  9.0570752
              ],
              "_id": "6311442da0ebe3001607e006"
          },
          "password": "bml5aW5peWk=",
          "username": "worldest",
          "video": "avatar"
      }
    }
  );

  useEffect(() => {
    const getUser = localStorage.getItem("user");
    const user_ = localStorage.getItem("user");
    setUser(user_);
    fetch(`https://keyedin-nodejs.herokuapp.com/api/v1/wallets/balance/${user.data._id}`, {
      method: "GET"
    })
    .then(res => res.json())
    .then(data => {
      console.log(data)
      setWallet(`${data.data.currency_code} ${data.data.available_balance}`);
    })
  }, [])

  return (
    <Page title="Wallet">
      <RootStyle>
        <HeaderStyle>
          <Logo />

          
        </HeaderStyle>

        {mdUp && (
          <SectionStyle>
            <Typography variant="h3" sx={{ px: 5, mt: 10, mb: 5 }}>
                <span style={{fontSize: 12}}>Wallet Balance</span><br />
                {wallet}
            </Typography>
            <img src="/static/illustrations/wallet.webp" alt="wallet" />
          </SectionStyle>
        )}

        <Container maxWidth="sm">
          <ContentStyle>
            <Typography variant="h4" gutterBottom>
              Top-Up Wallet
            </Typography>

            <Typography sx={{ color: 'text.secondary', mb: 5 }}>Enter your details below.</Typography>

            

            <TopUpForm />

            
          </ContentStyle>
        </Container>
      </RootStyle>
    </Page>
  );
}
